export default {
    inserted: function (el) {
        setTimeout(() => { el.focus() }, 5)
    }
}